<template>
  <div class="row sectiondiv">
    <div class="col-lg-6">
      <div class="overall">
        <div class="audio">
          <h4>Audio</h4>
          <audio ref="audioPlayer" :src="audioSrc" controls class="audioplayer" @ended="onAudioEnd"></audio>
        </div>

        <div class="names" aria-colspan="10">
          <h4>Call Related Tags</h4>
          <div class="namesss">
            <div v-for="(tag, index) in buttonNames" :key="index">
              <v-btn :class="{ 'active-button': selectedButton === tag.name }" @click="handleTagClick(tag)"
                class="buttonclick">
                {{ tag.name }}
              </v-btn>
            </div>
          </div>
        </div>

        <div class="sentiment">
          <h4>Sentiment Analysis</h4>
          <div class="img">
            <div v-for="(emoji, index) in emojis" :key="index" class="emoji-container"
              :style="{ backgroundColor: emoji.backgroundColor }">
              <div class="custom-progress">
                <v-progress-linear v-model="emoji.progress" :color="emoji.progressColor" :height="20" />
              </div>
              <img :src="emoji.src" :alt="emoji.name" />
              <p class="nameemoji">{{ emoji.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="calltranscription">
        <h4>Call Transcription</h4>
        <div class="calltranscriptioncontent">
          <span></span>
          <p v-for="(line, index) in highlightedTextLines" :key="index" :class="line.class" v-html="line.text"
            ref="textLine"></p>
        </div>


        <div class="summary">
          <h4>Summary</h4>
          <p>{{ summary }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AngryEmoji from "@/assets/icons/Angry_emoji-removebg-preview 1.png";
import ConfusedEmoji from "@/assets/icons/Confused_emoji-removebg-preview 1.png";
import HappyEmoji from "@/assets/icons/Happy_emoji-removebg-preview 1.png";

export default {
  mounted() {
    this.statusCode = this.$route.query.statusCode || '404'; // Default to '404' if no query parameter is provided

    this.fetchTags();
    const uniqueid = this.$route.query.uniqueid;
    const date = this.$route.query.date
    if (uniqueid) {
      this.fetchCallTranscription(uniqueid, date);
    } else {
      console.error("Unique ID is missing.");
    }
  },
  data() {
    return {
      buttonNames: [],
      page: {
        playingRecord: false,
      },
      audioSrc: "",
      textLines: [],
      summary: "",
      sentimentData: null,
      selectedButton: "",
      highlightText: "",
      emojis: [
        {
          name: "Negative",
          src: AngryEmoji,
          progress: 0,
          progressColor: "#FE824C",
          backgroundColor: "#FE824C33",
        },
        {
          name: "Neutral",
          src: ConfusedEmoji,
          progress: 0,
          progressColor: "#FFE366",
          backgroundColor: "#FFE36633",
        },
        {
          name: "Positive",
          src: HappyEmoji,
          progress: 0,
          progressColor: "#FE326C",
          backgroundColor: "#FD336C33",
        },
      ],
    };
  },

  computed: {
    highlightedTextLines() {
      return this.textLines.map((line) => {
        if (this.highlightText) {
          const regex = new RegExp(`(${this.highlightText})`, "gi");
          return {
            ...line,
            text: line.text.replace(regex, '<span class="highlight">$1</span>'),
          };
        }
        return line;
      });
    },
  },


  methods: {

    getLineClass(line) {
      if (line.includes(this.highlightText)) {
        return "highlight-line";
      }
      return "normal-line";
    },

    async fetchTags() {
      try {
        const tagsResponse = await this.$store.dispatch("LeadTags");
        console.log("Fetched tags:", tagsResponse, tagsResponse.count);
        if (tagsResponse && Array.isArray(tagsResponse.data)) {
          this.buttonNames = tagsResponse.data.map((tag) => ({
            name: tag.name,
            id: tag.id,
          }));
        }
        else {
          this.buttonNames = [{
            name: "No tags are added",
            id: null
          }];
        }
      } catch (error) {
        console.error("Error fetching tags:", error);
        this.buttonNames = [];
      }
    },
    handleTagClick(tag) {
      this.selectedButton = tag.name;
      this.highlightText = tag.name;
      console.log("Selected tag for highlighting:", this.highlightText);
    },
    getHighlightedText(text) {
      if (this.highlightText) {
        const regex = new RegExp(`(${this.highlightText})`, "gi");
        return text.replace(regex, '<span class="highlight">$1</span>');
      }
      return text;
    },
    async fetchCallTranscription(uniqueid, audiodate) {
      try {
        console.log("Fetching transcription for uniqueid:", uniqueid);
        let payload = {
          uniqueids: [uniqueid], date: audiodate
        }
        const response = await this.$store.dispatch("CallTranscriptionfetch", payload);

        console.log("API response:", response.data.data);
        console.log("Status Code:", response.status);
        if (response.status === 204) {
          this.$router.push({ path: "/error", query: { statusCode: '404' } });
      return;
 
          }
        if (!response.data.data || !Array.isArray(response.data.data)) {
          throw new Error("Unexpected response structure");
        }

        const data = response.data.data[0];
        console.log("Parsed data:", data);
        this.fetchAudioUrl(uniqueid, audiodate);

        const transcriptionLines = (data.transcription || "").split("\n");

        const isEmptyConversation = transcriptionLines.every(line => line.trim() === "Speaker Unknown:");

        if (isEmptyConversation) {
          this.textLines = [{ text: "There is no conversation in this audio.", class: "customer-line" }];
          this.summary = "There is no conversation in this audio.";
        } else {
          this.textLines = transcriptionLines.map((line, index) => {
            const formattedText = line.replace(/^Speaker\s*/, "");
            return {
              text: formattedText, // The cleaned text
              class: index % 2 === 0 ? "customer-line" : "executive-line", // Alternate class based on index
            };
          });

          this.summary = data.summary || "No summary available";
        }

        let sentimentData = {};
        try {
          const cleanedSentimentString = data.sentiment.replace(/\\"/g, '"').slice(1, -1);
          console.log("Cleaned sentiment string:", cleanedSentimentString);

          sentimentData = JSON.parse(cleanedSentimentString);
          console.log("Parsed sentiment data:", sentimentData);

          const confidenceScores = sentimentData.confidence_scores || {};
          if (Object.keys(confidenceScores).length === 0) {
            console.error("Confidence scores are empty.");
            return;
          }

          console.log("Confidence scores:", confidenceScores);

          const positive = Math.round((confidenceScores.positive || 0) * 100);
          const neutral = Math.round((confidenceScores.neutral || 0) * 100);
          const negative = Math.round((confidenceScores.negative || 0) * 100);

          console.log("Negative progress:", negative);
          console.log("Neutral progress:", neutral);
          console.log("Positive progress:", positive);

          this.$set(this.emojis[0], 'progress', negative); // Angry
          this.$set(this.emojis[1], 'progress', neutral); // Confused
          this.$set(this.emojis[2], 'progress', positive); // Happy

          console.log("Updated emojis:", this.emojis);
        } catch (error) {
          console.error("Error parsing sentiment data:", error);
        }
      } catch (error) {
        console.error("Failed to fetch call transcription:", error);
        this.textLines = [{ text: "Error fetching transcription", class: "customer-line" }];
        this.summary = "Error fetching summary";
        this.audioSrc = "";
      }
    },

    handleClick(name) {
      this.selectedButton = name;
    },

    async fetchAudioUrl(uniqueid, date) {
      try {
        const tid = JSON.parse(localStorage.apiInfo).tenant_code
        const response = await this.$store.dispatch("audioplay", { id: uniqueid, tid, date });
        console.log(response, "Fetched audio URL");
        this.audioSrc = response.url || "";

      } catch (error) {
        console.error("Error fetching audio URL:", error);
      }
    },
    onAudioEnd() {
      console.log("Audio playback ended.");
    }
  },
};
</script>

<style>
.customer-line {
  border-left: 6px solid #2196f3;
  padding-left: 8px;
  margin-bottom: 32px;
  border-top-left-radius: 3px;          
  border-bottom-left-radius: 3px;       
  border-top-right-radius: 3px;         
  border-bottom-right-radius: 3px;       
}

.executive-line {
  border-left: 6px solid #91ceff;
  padding-left: 8px;
  margin-bottom: 32px;
  border-top-left-radius: 3px;          
  border-bottom-left-radius: 3px;       
  border-top-right-radius: 3px;         
  border-bottom-right-radius: 3px; 
}

.names {
  width: 600px;

  padding: 10px;
  margin-top: 25px;
  margin-left: 7px;
}

.names h4 {
  font-size: 17px;
  font-weight: 700;
}

.sentiment h4 {
  font-size: 17px;
  font-weight: 700;
  margin-top: 70px;
  margin-left: 10px;
}


.calltranscription {
  margin-top: 38px;
  height: 609px;
}

.calltranscription p {
  font-size: 14px;
}

.calltranscription h4 {
  font-size: 17px;
  font-weight: 700;
  margin-left: 14px;
}

.audio h4 {
  font-size: 17px;
  font-weight: 700;
  margin-left: 16px;
}

.calltranscriptioncontent {
  height: 350px;
  padding: 15px;
  overflow: auto;
  margin-bottom: 21px;
  width: 631px;
}

.summary {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.summary p {

  color: #4A4A4A;
  font-size: 14px;
  margin-left: 4px;
  margin-bottom: 0px !important;
  height: 150px;
  padding: 15px;
  overflow-y: auto;
  text-align: justify;
  word-spacing: 2px;

}

.namesss {

  display: flex;
  width: 608px;
  flex-wrap: wrap;
  overflow-y: auto;
  height: 100px;

}

.sentimenttag {
  display: flex;

  flex-wrap: wrap;
  overflow-y: auto;
}

.sentimenttag button {

  border-radius: 10px;
}

.sentiment {
  width: 600px;
  padding: 8px;
  /* margin-top: -36px; */
  height: 319px;
}

/* .img{
    display: flex;
    justify-content: space-around;
    padding-top: 24px;
} */
.img {
  display: flex;
  gap: 39px;
  padding-top: 33px;

}

.emoji-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 170px;
  height: 180px;
  padding: 8px;
  border-radius: 8px;
  gap: 14px;
}

.custom-progress {
  height: 100px;
  width: 100px;
  transform: rotate(-90deg);
  margin: 0px 7px;
  position: relative;
  top: 20px;
  left: 84px;
}

.custom-progress v-progress-linear {
  height: 100%;
}

/* .vertical-progress {

  height: 18px !important;
  transform: rotate(-90deg);
  margin: 0px 7px;
  position: relative;
  top: 64px;
  left: 49px;
} */


.v-progress-linear__bar {
  background-color: #fff !important;
}

.v-progress-linear__background {
  height: 18px !important;
}

.emoji-container img {
  width: 75px;
  height: 75px;
  margin-top: -78px;
  margin-left: -46px;
}

.vertical-progress {
  width: 100%;
  /* Set width to match container */
  margin-bottom: 5px;
}

.nameemoji {
  margin-left: -18px;
  font-size: 16px;
  font-weight: 700;
}

.sectiondiv {
  width: 100%;
  height: 74vh;
}

.highlight {
  background-color: #2196f3;
  color: #fff;
  font-weight: bold;
}

.audio {
  width: 100%;
}

.summary h4 {
  margin-left: 19px !important;
}

.summary {
  width: 643px;
  margin-left: -13px;
  height: 247px;
  padding: 30px;
  background-color: #fff;
  width: 645px;
  margin-left: -13px;
  height: 214px;
  padding: 15px;
  background-color: #fff;
}

.buttonclick {

  border-radius: 15px;
}

.buttonclick:hover {
  background-color: #fff !important;
}

.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: #fff;
  border: 1px solid;
}

.active-button {

  color: #2196f3 !important;
  /* Text color for the active button */
  font-weight: bold;
}



.v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
  will-change: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}


.audio {


  padding-top: 24px;
  margin-left: 3px;
  border-radius: 15px;
}

.audioplayer {
  width: 96%;
}

.overall {
  -webkit-box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  width: 100%;
  margin-left: 2px;
  height: 650px;
  background-color: #fff;
  position: absolute;
  z-index: 1;
}
</style>